module.exports = __webpack_public_path__ + "img/115ne.1000e507.svg";